import React from 'react';
import AgreementBanner from './AgreementBanner';
import ComparisonTable from './ComparisonTable';
import FestivalDiffsSection from './FestivalDiffsSection';
import EducationalPanel from './EducationalPanel';
import DetailedValuesToggle from './DetailedValuesToggle';

const ComparisonView = ({ result, now, lang = 'en' }) => {
  if (!result || !result.drik || !result.vakyam || !result.deltas || !result.summary) {
    return null;
  }

  return (
    <div>
      <AgreementBanner level={result.summary.agreement_level} lang={lang} />
      <ComparisonTable result={result} lang={lang} />
      <FestivalDiffsSection diffs={result.deltas.festival_diffs} lang={lang} />
      <EducationalPanel lang={lang} />
      <DetailedValuesToggle
        drik={result.drik}
        vakyam={result.vakyam}
        now={now}
        lang={lang}
      />
    </div>
  );
};

export default ComparisonView;
